import { get, post, put, del } from "./api";
import type {
  ComposeXPostRequest,
  ComposeXPostResponse,
  CreateXPostRequest,
  XPostResponse,
  XPostTemplateRequest,
  XPostTemplateResponse,
} from "../types/crm";

// X Posts
export const composeXPost = (request: ComposeXPostRequest): Promise<ComposeXPostResponse> =>
  post("/api/crm/x-posts/compose", request);

export const createXPost = (request: CreateXPostRequest): Promise<XPostResponse> =>
  post("/api/crm/x-posts", request);

export const getXPostsForProfile = (profileId: string): Promise<XPostResponse[]> =>
  get(`/api/crm/prospect-profiles/${profileId}/x-posts`);

// Templates
export const getTemplates = (): Promise<XPostTemplateResponse[]> =>
  get("/api/crm/x-post-templates");

export const getTemplate = (id: string): Promise<XPostTemplateResponse> =>
  get(`/api/crm/x-post-templates/${id}`);

export const createTemplate = (request: XPostTemplateRequest): Promise<XPostTemplateResponse> =>
  post("/api/crm/x-post-templates", request);

export const updateTemplate = (id: string, request: XPostTemplateRequest): Promise<XPostTemplateResponse> =>
  put(`/api/crm/x-post-templates/${id}`, request);

export const deleteTemplate = (id: string): Promise<void> =>
  del(`/api/crm/x-post-templates/${id}`);
